import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-center pt-4" }
const _hoisted_2 = { class: "bg-primary installation-modal-icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "QR-code installation")
], -1)
const _hoisted_4 = { class: "qr mt-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "sm mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 w-100" }, null, -1)
const _hoisted_8 = { class: "installation-modal-icon bg-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", { class: "mt-2 pb-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "QR-code installation")
], -1)
const _hoisted_10 = { class: "manual-installation-info mt-4" }
const _hoisted_11 = { class: "d-flex py-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", { class: "font-15 me-3 color-primary" }, [
  /*#__PURE__*/_createElementVNode("b", null, "SM-DP+Address: ")
], -1)
const _hoisted_13 = { class: "sm" }
const _hoisted_14 = { class: "d-flex py-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", { class: "font-15 me-3 color-primary" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Activation code: ")
], -1)
const _hoisted_16 = { class: "sm" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "d-flex w-100 justify-content-end page-heading-toolbar" }
const _hoisted_19 = { class: "page-heading-toolbar--col" }
const _hoisted_20 = { class: "page-heading-toolbar--col" }
const _hoisted_21 = { class: "profiles-wrapper" }
const _hoisted_22 = {
  key: 0,
  class: "profiles-preloader"
}
const _hoisted_23 = {
  key: 0,
  class: "slot-details"
}
const _hoisted_24 = { class: "slot-details--heading" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "slot-details--body" }
const _hoisted_27 = { class: "slot-details-inner py-5" }
const _hoisted_28 = { class: "slot-details--body__table mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_DragAndDrop = _resolveComponent("DragAndDrop")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_BtnContent = _resolveComponent("BtnContent")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_PageMainHeading = _resolveComponent("PageMainHeading")!
  const _component_AppPreloader = _resolveComponent("AppPreloader")!
  const _component_HeadToolBar = _resolveComponent("HeadToolBar")!
  const _component_AppTabsHead = _resolveComponent("AppTabsHead")!
  const _component_ProfileSlotDetails = _resolveComponent("ProfileSlotDetails")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_AppTableController = _resolveComponent("AppTableController")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      title: _ctx.installationTitle,
      opened: _ctx.installationModalOpened,
      "modal-loading": _ctx.modalLoading,
      onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.installationModalOpened = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_svg_icon, { icon: "qr" })
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.qr.image,
              alt: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.qr.iccid), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_svg_icon, { icon: "manual" })
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.qr.address), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.qr.code), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "opened", "modal-loading"]),
    _createVNode(_component_Dialog, {
      title: "Profile upload",
      opened: _ctx.importModalOpened,
      "can-close": !_ctx.uploadLoading,
      onHide: _ctx.hideImportModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DragAndDrop, {
          accepted: ['XLS', 'XLSX'],
          loading: _ctx.uploadLoading,
          progress: _ctx.uploadProgress,
          "upload-success": _ctx.uploadSuccess,
          "upload-error": _ctx.uploadErrorMessage,
          onFileChanged: _ctx.importFile
        }, null, 8, ["loading", "progress", "upload-success", "upload-error", "onFileChanged"])
      ]),
      _: 1
    }, 8, ["opened", "can-close", "onHide"]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_PageMainHeading, { title: "Profiles" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_SelectDropdown, {
                list: _ctx.appRefs.filter,
                icon: "calendar-2",
                "on-select": _ctx.appRefs.onFilterSelect
              }, null, 8, ["list", "on-select"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (!_ctx.isResellerProvider)
                ? (_openBlock(), _createBlock(_component_AppButton, {
                    key: 0,
                    size: "xl",
                    type: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.importModalOpened = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BtnContent, {
                        icon: "plus",
                        label: "Import File"
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_AppButton, {
                    key: 1,
                    size: "xl",
                    type: "secondary",
                    loading: _ctx.buttonLoading,
                    onClick: _ctx.synchronizeResellerProfiles
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BtnContent, { label: "Synchronize" })
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_AppPreloader)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.providersTitles.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_HeadToolBar, {
                  class: "provider-tabs",
                  tabs: _ctx.providersTitles,
                  "initial-selected-tab": _ctx.activeProviderIdx,
                  "parent-selected-tab-id": _ctx.activeProviderIdx,
                  onChangeTab: _ctx.changeTab
                }, null, 8, ["tabs", "initial-selected-tab", "parent-selected-tab-id", "onChangeTab"]),
                (
              !_ctx.isResellerProvider && _ctx.slotsTitles.length && _ctx.serversTitles.length
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_AppTabsHead, {
                        modelValue: _ctx.activeTypeIdx,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTypeIdx) = $event)),
                        tabs: _ctx.slotsTitles
                      }, null, 8, ["modelValue", "tabs"]),
                      _createVNode(_component_AppTabsHead, {
                        modelValue: _ctx.activeServerIdx,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeServerIdx) = $event)),
                        tabs: _ctx.serversTitles
                      }, null, 8, ["modelValue", "tabs"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ProfileSlotDetails, {
                    "show-details": !_ctx.isResellerProvider,
                    "file-name": _ctx.activeServer.fileName,
                    "date-uploaded": _ctx.activeServer.uploadedDate,
                    inventory: 
                !_ctx.isResellerProvider
                  ? _ctx.activeServer.total
                  : _ctx.resellerCountData.total
              ,
                    used: 
                !_ctx.isResellerProvider ? _ctx.activeServer.used : _ctx.resellerCountData.used
              ,
                    free: 
                !_ctx.isResellerProvider ? _ctx.activeServer.free : _ctx.resellerCountData.free
              ,
                    "last-used": 
                !_ctx.isResellerProvider
                  ? _ctx.activeServer.updatedDate
                  : _ctx.resellerCountData.updated
              
                  }, null, 8, ["show-details", "file-name", "date-uploaded", "inventory", "used", "free", "last-used"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_AppTableController, {
                    "show-table": !!_ctx.profiles.length,
                    "empty-key": "profiles",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppTable, {
                        "table-head": _ctx.cells,
                        "table-body": _ctx.rows,
                        "total-rows": _ctx.totalProfiles,
                        "current-page": _ctx.tableRefs.viewConfiguration.page,
                        "per-page": _ctx.tableRefs.viewConfiguration.perPage,
                        "pagination-capture-key": "Profiles",
                        onChangeViewConfiguration: _ctx.tableRefs.changeViewConfiguration,
                        onSort: _ctx.tableRefs.changeSorting
                      }, null, 8, ["table-head", "table-body", "total-rows", "current-page", "per-page", "onChangeViewConfiguration", "onSort"])
                    ]),
                    _: 1
                  }, 8, ["show-table"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}